<template>
  <DialogTemplate data-tst="solfigr_rakedialog">
    <button
      v-if="isDev && eliteMTTTierPurchased"
      class="dev-prefills ml-auto"
      @click="devPrefill"
    >
      dev-prefill
    </button>

    <SolfigrIcmMessages
      v-if="!eliteMTTTierPurchased"
      :messages="['upgrade_to_elite_mtt_unlock_icm_tournament_search']"
      style="--clr-message-back: var(--clr-black-0-2)"
    />

    <div
      v-else
      class="flex-1"
      style="position: relative"
    >
      <div
        v-if="!search_call.loaded"
        :class="{ opacity_0: search_call.loading }"
        class="f-column transition_03"
        tabindex="1"
        style="min-width: clamp(1px, 28rem, calc(100vw - 2rem)); gap: 1rem"
        @keydown.enter.stop="handleEnter"
      >
        <div class="text-large my-auto weight_700 text-nowrap">
          {{ $t('solfigr.icm.search_tournament_by_id') }}
        </div>
        <div
          class="f-column"
          style="gap: 1rem"
        >
          <div
            class="f-column"
            style="gap: 1rem"
          >
            <div class="f-column">
              <div
                class="text-medium clr-grey"
                style="margin: 0px 0px 0.25rem"
              >
                {{ $t(`solfigr.icm.pokersite`) }}
              </div>
              <div
                class="f-column large-scroll-track no-shrink"
                style="max-height: 24rem; overflow: auto"
              >
                <GwBtns
                  :options
                  :values="selectedOptions"
                  style="
                    padding: 0;
                    --gwbtns-wrap: wrap;
                    --gwbtns-gap: 0.25rem;
                    --gwbtn-justify-content: flex-start;
                    --gwbtn-size: 1rem;
                    --gwbtn-height: 2rem;
                    flex-flow: column;
                  "
                  btnClass="gw_btn_active_sticky"
                  @click.stop="
                    (_e, item) => {
                      handleClick(item)
                    }
                  "
                >
                  <template #default="{ item }">
                    <slot :item="item">
                      <GwSiteItem
                        style="min-width: 13rem"
                        :siteId="item"
                        :disableTranslate="true"
                      />
                    </slot>
                  </template>
                </GwBtns>
              </div>
            </div>

            <GwInput
              :label="$t('solfigr.icm.tournament_id')"
              style="--input-height: 2.5rem"
              type="text"
              :getErrors
              :value="inputValue"
              @input="(_e, value) => (inputValue = value.trim())"
              @keydown:enter="search"
            />
          </div>
        </div>

        <div
          data-tst="search_dialog_cta"
          class="gw_btn-v1"
          :class="`${canSearch ? 'gw_btn_primary' : 'gw_btn_disabled no-events'}`"
          style="--clr-disabled: var(--clr-grey-2); --clr-back-disabled: var(--clr-black-2)"
          @click="search"
        >
          <div class="mdi mdi-magnify text-normal-large mr-1"></div>
          {{ $t('common.search') }}
        </div>
      </div>

      <div
        v-else-if="search_call.loaded || search_call.loading"
        style="gap: 0.5rem"
        class="f-column f-center"
      >
        <LoaderSpinner
          v-if="search_call.loading"
          :style="`--size:4rem`"
          style="min-height: 3.5rem"
        />
        <div
          v-if="search_call.loaded"
          class="f-column"
          style="gap: 0.5rem"
        >
          <IconAndText
            v-if="search_call.error && search_call.status === 429"
            icon="mdi-alert-circle-outline"
            class="pa-4"
            style="--icon-size: 5rem; --icon-color: var(--clr-yellow)"
            :title="$t('solfigr.icm.tournament_search_daily_quota_depleted', { num: 100 })"
            :subtitle="$t('solfigr.icm.tournament_search_daily_quota_depleted_subtitle')"
          />
          <IconAndText
            v-else-if="search_call.error && search_call.status === 400"
            icon="mdi-information-outline"
            class="pa-4"
            style="--icon-size: 5rem; --icon-color: var(--clr-blue)"
            :title="$t('solfigr.icm.no_tournament_found')"
            :subtitle="$t('solfigr.icm.no_tournament_found_subtitle')"
          />
          <IconAndText
            v-else-if="search_call.error"
            data-tst="search_call_error"
            icon="mdi-alert-circle-outline"
            class="pa-4"
            style="--icon-size: 5rem; --icon-color: var(--clr-error)"
            :title="$t('messages.oops_error')"
            :subtitle="$t('messages.opps_error_sub')"
          >
            <div class="clr-grey text-small mt-2">
              <div>
                status: {{ search_call.status }}
                {{
                  (![500, 502].includes(search_call.status) &&
                    JSON.stringify(search_call.error?.response?.data || {})
                      .replace(/[{}""]/g, '')
                      .replace(/[:]/g, ': ')
                      .split(',')
                      .join('\n')) ||
                  ''
                }}
              </div>
            </div>
          </IconAndText>
          <div
            v-else
            class="f-column"
            style="gap: 1rem"
          >
            <SolfigrIcmTournamentStructureItem
              v-if="data"
              :item="data"
              style="--clr-box-back: var(--clr-black-1-3)"
              class="gw_box"
            />
          </div>
        </div>
        <div
          v-if="search_call.loaded"
          class="gw_btn-v1 w-100"
          data-tst="search_call_retry"
          @click.stop="search_call.loaded = false"
        >
          <i class="mdi mdi-replay text-semi-large mr-2"></i>
          {{ $t('btn.retry') }}
        </div>
        <div
          v-if="search_call.loaded && data"
          data-tst="search_icm_apply"
          class="gw_btn-v1 gw_btn_primary w-100"
          @click.stop="apply"
        >
          <i class="mdi mdi-check text-semi-large mr-2"></i>
          {{ $t('btn.apply') }}
        </div>
      </div>
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        data-tst="btn_close"
        variant="text"
        @click="close"
        >{{ $t('btn.close') }}</v-btn
      >
    </template>
  </DialogTemplate>
</template>

<script>
import SolfigrIcmTournamentStructureItem from '@/components/Dialogs/Solfigr/SolfigrIcmTournamentStructureItem'
import GwSiteItem from '@/components/DataTables/Filters/new/items/GwSiteItem'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import IconAndText from '@/components/Poker/Overlays/IconAndText'
import GwBtns from '@/components/lib/GwBtns'
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import { applyTournamentStructure, getIcmTournamentSites } from '@/store/solfigr/solfigr_helpers'
import { toggleArr } from '@/helpers/helpers'
import GwInput from '@/components/lib/GwInput'
import SolfigrIcmMessages from '@/components/ConfigureSolution/SolfigrIcmMessages'
import fetch_mix from '@/mixins/fetch_mix'

export default {
  name: 'SolfigrIcmStructuresSearchDialog',
  components: {
    GwInput,
    SolfigrIcmMessages,
    SolfigrIcmTournamentStructureItem,
    GwSiteItem,
    LoaderSpinner,
    IconAndText,
    GwBtns,
    DialogTemplate,
  },
  mixins: [fetch_mix],
  props: {
    dialog: Object,
  },
  data() {
    this.options = getIcmTournamentSites()

    return {
      selectedOptions: [],
      inputValue: '',
      search_call: {
        conf: {
          method: 'post',
          endpoint: 'tournaments/search/',
          apiVersion: 'v4',
          data: {},
        },
        loading: false,
        loaded: false,
        status: 0,
        error: null,

        // dev----
        // loaded: true,
        // error: true,
        // status: 429,
        // status: 400,
        // status: 500,
      },
      data: null,
    }
  },
  methods: {
    devPrefill() {
      // test with
      // 3752727648
      // PokerStars
      this.inputValue = '3752727648'
      this.selectedOptions = ['PokerStars']
      this.search()
    },

    getErrors() {
      if (!(this.inputValue || '').trim().length) {
        return [this.$t(`messages.field_empty_error`)]
      }
      return []
    },
    handleEnter() {
      if (this.search_call.loaded && this.data) this.apply()
      if (this.canSearch) this.search()
    },
    handleClick(item) {
      const res = toggleArr({ arr: this.selectedOptions, item, addToStart: true })
      this.selectedOptions = [res[0]].filter(Boolean)
    },
    async search() {
      if (!this.canSearch) return
      this.search_call.loaded = false
      this.search_call.error = null
      this.data = null
      const item = {
        tournament_id: this.inputValue,
        site: this.selectedOptions[0],
      }
      this.search_call.conf.data = item
      const { data, error } = await this.fch_getData(this.search_call)
      // console.log(this.search_call)
      if (error) return
      this.data = data
    },
    apply() {
      applyTournamentStructure({ item: this.data, namespace: this.namespace, store: this.$store })
      this.close()
    },
    close() {
      this.$store.dispatch('router_rm_dialog', 'solfigr-icm-structures-search-dialog')
    },
  },
  computed: {
    isDev() {
      return import.meta.env.VITE_ENV !== 'production'
    },
    eliteMTTTierPurchased() {
      return this.$store.getters.sol_eliteMTTTierPurchased
    },
    canSearch() {
      return this.inputValue && this.selectedOptions.length
    },
    namespace() {
      return this.dialog.namespace || null
    },
  },
}
</script>
